import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import { buildScoreCurve } from '../pages/communityScoringUtils';

const CommunityScoreChart = ({ events = [], duration = 0, compact = false }) => {
  const { t } = useI18n();
  const points = buildScoreCurve(events, duration);
  const scores = points.map((point) => point.score);
  const min = Math.min(-1, ...scores);
  const max = Math.max(1, ...scores);
  const width = 800;
  const height = compact ? 110 : 190;
  const timeSpan = Math.max(duration, points[points.length - 1].time, 1);
  const scoreSpan = max - min;
  const coordinates = points.map((point) => ({
    x: (point.time / timeSpan) * width,
    y: height - ((point.score - min) / scoreSpan) * height,
  }));
  const zeroY = height - ((0 - min) / scoreSpan) * height;
  let path = `M ${coordinates[0].x} ${coordinates[0].y}`;
  for (let index = 1; index < coordinates.length; index += 1) {
    path += ` H ${coordinates[index].x} V ${coordinates[index].y}`;
  }

  return (
    <div className={`community-score-chart${compact ? ' compact' : ''}`}>
      <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label={t('community.chart.label')}>
        <line x1="0" y1={zeroY} x2={width} y2={zeroY} className="community-chart-zero" />
        <path d={path} className="community-chart-line" />
        {coordinates.slice(1, -1).map((point, index) => (
          <circle
            key={`${events[index]?.time}-${index}`}
            cx={point.x}
            cy={point.y}
            r="4"
            className={events[index]?.delta === 1 ? 'community-chart-plus' : 'community-chart-minus'}
          />
        ))}
      </svg>
    </div>
  );
};

export default CommunityScoreChart;
